var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"airtable-embed",staticStyle:{"background":"transparent","border":"1px solid #ccc","height":"100%"},attrs:{"src":_vm.url,"frameborder":"0","onmousewheel":"","width":"100%","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }